// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').run(function ($document) {
  $document.on('track.siteCatalystBeforeSend', function (e, data) {
    if (tracking_data['merch-link']) {
      tracking_data.nav = tracking_data['merch-link'];
    }
    if (tracking_data['carousel-link']) {
      tracking_data.more_results = tracking_data.carousel_interaction =
        tracking_data['carousel-link'];
    }
    if (tracking_data['carousel-link']) {
      tracking_data.nav = tracking_data['carousel-link'];
    }
    $.extend(data.pageTrackingVariables);
  });

  $document.on('carouselImageClick', function (e, params) {
    const carouselName = params['title'];
    tracking_data.carousel_interaction = 'Carousel|' + carouselName;
    return;
  });

  $document.on('carouselArrowClickLeft', function (e, params) {
    tracking_data.carousel_interaction = `Carousel|Left|${params['title']}`;
    return;
  });

  $document.on('carouselArrowClickRight', function (e, params) {
    tracking_data.carousel_interaction = `Carousel|Right|${params['title']}`;
    return;
  });

  $document.on('track.landing.merchOfferings', function (e, params) {
    const tabTitle = $(params.currentTarget).text();
    return window.dataLayer != null
      ? window.dataLayer.push({
          event: 'search',
          active_search_tab: tabTitle,
        })
      : undefined;
  });

  $document.on('track.landing.merchPricing', function (e, params) {
    const tabTitle = $(params.currentTarget).text();
    return window.dataLayer != null
      ? window.dataLayer.push({
          event: 'search',
          active_search_tab: tabTitle,
        })
      : undefined;
  });

  $document.on('track.landing.merchSolutions', function (e, params) {
    const tabTitle = $(params.currentTarget).text();
    return window.dataLayer != null
      ? window.dataLayer.push({
          event: 'search',
          active_search_tab: tabTitle,
        })
      : undefined;
  });

  $document.on(
    'track.landing.merchPricingiStockEssentials',
    function (e, params) {
      tracking_data.nav = 'merch_pricing_iStockEssentials';
      return;
    }
  );

  $document.on(
    'track.landing.merchPricingiStockSignature',
    function (e, params) {
      tracking_data.nav = 'merch_pricing_iStockSignature';
      return;
    }
  );

  $document.on('track.landing.merchPricingiStockPacks', function (e, params) {
    tracking_data.nav = 'merch_pricing_iStockPacks';
    return;
  });

  $document.on('track.landing.merchPricingUltraPacks', function (e, params) {
    tracking_data.nav = 'merch_pricing_iStockPacks';
    return;
  });

  $document.on(
    'track.landing.merchSolutionsMediaManager',
    function (e, params) {
      tracking_data.nav = 'merch_solutions_DigitalAssetManagement-MediaManager';
      return;
    }
  );

  $document.on('track.landing.merchSolutionsImageNet', function (e, params) {
    tracking_data.nav = 'merch_solutions_GlobalMediaDistribution-ImageNet';
    return;
  });

  $document.on('track.landing.merchSolutionsAPI', function (e, params) {
    tracking_data.nav = 'merch_solutions_NoWorkflowInterruption-API';
    return;
  });

  $document.on('track.landing.subscriptionApi', function (e, params) {
    tracking_data.ui_element_location = 'subslp|txt';
    tracking_data.nav = 'exit_subslp_api';
    return;
  });

  $document.on('track.landing.subscriptionIstockLink', function (e, params) {
    tracking_data.nav = 'exit_subslp_istock';
    return;
  });
});
